import type { ApiTestMessages } from '../types';

const messages: ApiTestMessages = {
  'apiTestCase.messageError.praseError': '解析出错',
  'apiTestCase.messageError.csvFormatError': '不符合 CSV 格式',
  'apiTestCase.csvStandardRules': ' 《标准 CSV 规范》',
  'apiTestCase.report.statusCode': '状态码',
  'apiTestCase.report.statusLabel': 'HTTP 状态码: ',
  'apiTestCase.report.timeConsume': '耗时',
  'apiTestCase.report.TabSizeMap': '大小',
  'apiTest.label.actualRequest': '实际请求',
  'apiText.response.timings.event': '事件',
  'apiText.response.timings.event.prepare': '准备',
  'apiText.response.timings.event.socket': 'Socket 初始化',
  'apiText.response.timings.event.dns': 'DNS 查询',
  'apiText.response.timings.event.tcp': 'TCP 握手',
  'apiText.response.timings.event.ssl': 'SSL 握手',
  'apiText.response.timings.event.transfer': '等待中 (TTFB)',
  'apiText.response.timings.event.download': '下载内容',
  'apiText.response.timings.event.process': '处理',
  'apiText.response.timings.event.total': '总共',
  'apiText.response.timings.timeLabel': '时间',
  'apiTest.debug.extension.install': '安装',
  'apiTest.debug.extension.install.tips':
    '你需要安装 {appName} 浏览器插件来发送请求。仅支持 Chrome 与 Edge 浏览器。',
  'apiText.response.error.message.fallback': '错误：{message}',
  'apiText.response.error.help': '请求错误常见问题',
  'apiTest.debug.toSetVar': '去设置变量值',
  'apiTestCase.threadResources': '线程资源准备中',
  'apiTest.debug.usedTemplateVar': '接口使用了环境变量 {variables}',
  'apiTest.debug.setTemplateVar': '请先设置环境变量 {variables}',
} as const;

export default messages;
